import { gql } from '@apollo/client';
import { CreateNewRoleInput } from './createNewRole.queries';

export interface UpdateCustomRoleInput
  extends Partial<Omit<CreateNewRoleInput, 'organisation'>> {
  id: string;
}

export type UpdateCustomRoleResponse = {
  updateCustomRole: {
    message: string;
  };
};

export const UPDATE_CUSTOM_ROLE = gql`
  mutation updateCustomRole($input: UpdateCustomRoleInput!) {
    updateCustomRole(input: $input) {
      message
    }
  }
`;
